import { Box } from "@chakra-ui/react";
import { css } from "@emotion/react";
import { matchHeadFontCss } from "containers/MatchContainer/MatchContainer";
import { ColorIcon, colors, getCdnImageSrc, HStack, MQ, useResponsive, VStack } from "goi_common";

import React from "react";

const reviews = [
  {
    title:
      "고이 장례지도사님을 저희 아버지 장례지도사로 만나게 된 것은 하나님의 마지막 선물인 것 같습니다.",
    content:
      "경황도 없고 큰 슬픔에 빠진 저희 가족들에게 하나부터 열까지 진심으로 친절하게 꼼꼼히 챙겨주셨습니다. 아버지가 중환자실 투병을 오래하셔 몸에 상처가 많아 염하는 시간이 거의 2배로 걸렸습니다. 고이 장례지도사님의 그 진심에 어찌 감사를 다 표현할지 모르겠습니다. 공무원 상조 출신이시라 고품격 격식으로 장례식을 마지막까지 절도있고 품위있게 치뤄주셨습니다. 장례식 참석한 제 주위분들이 모두 고이 장례지도사님 명함을 받아가셨을정도로 정말 최고의 팀장님이십니다",
    name: "남**",
    profileSrc: "platform/match/profile/1.png",
  },
  {
    title: "제가 마지막으로 가장 잘한 효도인 것 같네요. 감사했습니다.",
    content:
      "갑작스럽게 어머님이 돌아가셔서 정신이 없는 가운데 고이에 전화를 하게되었습니다. 장례 3일동안 오로지 문상객에만 집중할 수 있게 모든 절차나 장지까지 전부 다 알아봐 주시고",
    name: "김**",
    profileSrc: "platform/match/profile/2.png",
  },
  {
    title: "언젠가 발생할 제 인생의 다른 상에도 고이와 함께하려고 합니다.",
    content:
      "아들이 먼저 갔는데 내가 나이가 많아 어찌해야 할지 막막했는데 최 선생이 멀리서 와서 신경 안 쓰게 알아서 다해주니까 너무 고마웠습니다. 세상에 아들 죽기 전에 미리 와주고 장례 발생해서 진행도 다 해주고 사망신고까지 나를 데리고서 행정처리까지 마무리해 주신 덕에 너무 미안하고 고마웠습니다. 나 같은 노인네 이렇게까지 해주시는 데 내가 몸 둘 바를 모르겠어요. 최 선생 은혜를 어찌 갚을까요. 죽어도 잊지 못합니다.",
    name: "김**",
    profileSrc: "platform/match/profile/3.png",
  },
  {
    title:
      "장례지도사님이 여성이라 더더욱 장모님과 집사람 등에 더 공감해주시면서 세심하게 도와주셔서 큰 도움이 됐습니다.",
    content:
      "연말에 갑작스럽게 장인어른이 쓰러지시고 중환자실에 의식 없이 입원하신지 일주일 정도만에 돌아가시면서 준비 없이 연락을 드렸습니다. 갑작스런 상황이었고 저와 집사람 모두 맏이고 집안에서 처음 겪는 부모님 상이다 보니 많이 당황스러웠습니다. 하지만 화장장 예약부터 장례식장 준비를 시작으로 장례 전 과정을 꼼꼼하고 친절하게 도와주시고 리드해 주셨습니다. 특히 허정원 장례지도사님이 여성이라 더더욱 장모님과 집사람 등에 더 공감해주시면서 세심하게 도와주셔서 큰 도움이 됐습니다. 특히 정신적으로 많이 힘드셨던 장모님이 정말 고맙다고 하시더군요. 상복, 수의나 관 등도 합리적으로 설명해주시고 추천해주셔서 예상보다 부담을 덜 느꼈습니다. 마지막 장지를 다녀와서 다시 장례식장에서 헤어질 때까지 한순간도 소홀함 없이 유족 입장에서 일을 해주셔서 큰 감명을 받았습니다.",
    name: "윤**",
    profileSrc: "platform/match/profile/4.png",
  },
  {
    title:
      "장례 경험이 없는 조문객들도 너무 좋으신 분이라고 다른 상조 회사 분들이랑 다르다고 말씀하시더라고요.",
    content:
      "할머니가 코로나로 인해 중환자실 2주 계시다 요양병원으로 가신 날 부터 준비를 해야할거같아 그때부터 알아보게 된 곳입니다. 상조가 이미 가입되어있었지만 고이와 비교 해보니 금액적으로 100만원 이상 차이도 났고 사용한 품목만 지불하는 후불제라는 시스템과 이용하신 분들의 진심어린 후기를 보니 이곳에서 해야한다는 생각이 들어 약 2주정도 소통을 한거같습니다. 다른 후불 상조회사도 있었지만 불시에 문의드렸을때도 바로 답변 주시고 시간 불문하고 저녁 늦게 전화 드려도 바로 받아 차분하게 들어주시고 설명해주셔서 어느정도 틀을 잡아놔 너무 안심이 되었습니다. 그리고 이주 후 전화 드렸을때 바로 받아주시고 출발 해주셔서 오시는 동안 다른 걱정없이 너무너무 든든했습니다. 온전히 할머니 보내드리는 것에만 집중 할 수 있게 도와주셔서 3일동안 문제없이 잘 보내 드렸네요. 저보다는 저희 가족들이 너무너무 감사하다고 입이 닳도록 저에게 본부장님 칭찬을 해주셔서 제가 몸둘바를 모르겠더라구요.. 가족들도 이런상황이 처음이라 무지했는데 본부장님 통솔하에 잘 마쳤습니다. 입구에 앉아계시며 신발정리도 해주시고 조문객들에게 조문하는 방법까지 잘 안내 해주셔서 경험이 없는 조문객들도 너무 좋으신분이라고 다른 상조회사분들이랑 다르다고 말씀하시더라구요. 가족들보다 오히려 못주무시고 눈이 충혈되셔서 너무 죄송하기도하고 감사했습니다. 믿고 의지할 수 있게 도와주신 본부장님 감사드려요 손녀인 저에게 우선권을 주셔서 마지막 봉안당까지 안고 갈수있어서 뜻깊었습니다. 모든게 잘 맞아서 발인날 비도 그쳤고 제일 좋은 봉안당 자리로 안치할 수 있게된게 너무 감사했습니다. 마지막 가는길 저희 할머니를 제일 많이 만져보신 분이셔서 왠지모를 유대감이 생기더라구요. 본부장님이 추후에 장례식장을 설립하여 사연있으신 분들께 무료로 이용 하게 해드리고 싶다는 말씀에 정말 사명감도 깊으시고 진심이 느껴졌습니다. 감사합니다 본부장님 틈틈이 쉬어가며 체력조절 하셨으면 좋겠습니다!!",
    name: "박**",
    profileSrc: "platform/match/profile/5.png",
  },
];

export default function ReviewSection() {
  const { setResponsive, isBiggerThanLg, isBiggerThanMd } = useResponsive();

  return (
    <VStack
      width="100%"
      alignItems="center"
      css={{ textAlign: "center" }}
      padding="100px 24px 72px"
      gap={isBiggerThanMd ? 16 : 12}
      background="linear-gradient(180deg, #FAFAFA 92.71%, rgba(250, 250, 250, 0) 100%)"
    >
      <div css={matchHeadFontCss}>
        장례 만족도 <span className="orange700">4.9</span>점,
        <br />
        이미 많은 상주님께서 {isBiggerThanMd || <br />}
        만족하셨습니다.
      </div>
      <div className={isBiggerThanLg ? "head2_m" : "body3_m"}>
        단 한 건의 거짓이나 과장 없이, {isBiggerThanMd || <br />}
        상주님께서 직접 작성한 후기입니다.
      </div>
      <Box
        gap="16px"
        flexWrap="wrap"
        display="flex"
        flexDirection={isBiggerThanMd ? "row" : "column"}
        width={setResponsive("100%", "800px", "1000px")}
        alignItems="center"
        justifyContent="center"
        padding={isBiggerThanLg ? "60px 0px 80px" : "32px 0px 60px"}
      >
        {reviews.map((review, index) => (
          <ReviewCard key={index} {...review} isTypeB={index === 3 || index === 4} />
        ))}
      </Box>
    </VStack>
  );
}

interface ReviewCardProps {
  title: string;
  content: string;
  name: string;
  profileSrc?: string;
  isTypeB: boolean;
}

function ReviewCard({ title, content, name, profileSrc, isTypeB }: ReviewCardProps) {
  return (
    <VStack gap={12} css={reviewCardCss.root({ isTypeB })}>
      <VStack gap={4}>
        <div className="gray900 pre-wrap" css={reviewCardCss.title}>
          {title}
        </div>
        <div className="caption1 gray700" css={reviewCardCss.content}>
          {content}
        </div>
      </VStack>

      <HStack gap={6} alignItems="center">
        {/* eslint-disable-next-line @next/next/no-img-element */}
        {profileSrc && <img alt="" src={getCdnImageSrc(profileSrc)} css={reviewCardCss.profile} />}
        <div className="gray400" css={reviewCardCss.name}>
          {name}님의 후기
        </div>
        <div css={reviewCardCss.line} />
        <HStack gap={1}>
          {[0, 1, 2, 3, 4].map((i) => (
            <ColorIcon key={i} name="rating_star" size={14} color={colors.orange650} />
          ))}
        </HStack>
      </HStack>
    </VStack>
  );
}

const reviewCardCss = {
  root: (props: { isTypeB: boolean }) =>
    css({
      maxWidth: "100%",
      padding: "22px 20px 24px",
      backgroundColor: colors.white,
      borderRadius: "16px",
      textAlign: "left",
      boxShadow: "0px 2px 12px rgba(0, 0, 0, 0.08)",
      [MQ.md]: {
        maxWidth: "320px",
      },
      [MQ.lg]: {
        maxWidth: props.isTypeB ? "400px" : "320px",
      },
    }),

  title: css({
    fontSize: "16px",
    lineHeight: "24px",
    fontWeight: 600,
    display: "-webkit-box",
    textOverflow: "ellipsis",
    overflow: "hidden",
    WebkitLineClamp: 2,
    WebkitBoxOrient: "vertical",
  }),

  content: css({
    display: "-webkit-box",
    textOverflow: "ellipsis",
    overflow: "hidden",
    WebkitLineClamp: 2,
    WebkitBoxOrient: "vertical",
  }),

  profile: css({
    width: "14px",
    height: "14px",
    borderRadius: "50%",
  }),

  name: css({
    fontSize: "12px",
    lineHeight: "14px",
    fontWeight: 500,
  }),

  line: css({
    width: "1px",
    alignSelf: "stretch",
    background: colors.gray200,
  }),
};
